import React, { FC, useState, ReactNode } from 'react';
import { User } from '../../../../models/User';
import { Log } from '../../../../models/Task';
import { Comment } from '../../../../models/Comment';
import Comments from './Comments';
import styles from './styles.module.css';
import cx from 'classnames';
import { UpdateComment } from '../../../../../shared/updateComment';
import { MentionableTask } from '../../../CreateTask/create_task/types';

export type Assignee = {
  id: number;
  name: string;
  email?: string;
  avatar?: string;
};

type Show = 'log' | 'comments';

export type CommentsAndLogSection = Show;

type Props = {
  container: ReactNode;
  createComment: (commentBody: any) => void;
  deleteComment: (commentId: number) => void;
  updateComment: UpdateComment;
  commentsLoading: boolean;
  comments: Comment[];
  currentUserId: number;
  users: User[];
  usersNotOnProject: User[];
  logs: Log[];
  logsLoading: boolean;
  taskId: number;
  canEditComment: boolean;
  canViewPrivateComments: boolean;
  canCreatePrivateComments: boolean;
  canViewCommitComment: boolean;
  billingRights: boolean;
  owner: User;
  bugherdUrl: string;
  organizationId: number;
  guestVisible: boolean;
  isSmallView?: boolean;
  isAdminView?: boolean;
  isNewSidebar?: boolean;
  onPlanUpgradeClick?: () => void;
  projectId: number;
  isExpandedView?: boolean;
  apiDomain: string;
  assignGuestsAllowed: boolean;
  assignGuests: boolean;
  assignees: Assignee[];
  mentionableTasks: MentionableTask[];
  searchMentionableTasks?: (
    query: string,
    callback: (results: unknown[]) => void
  ) => void;
  setActiveTask: (taskId: number) => void;
  onLogTabOpen: () => void;
  section?: CommentsAndLogSection;
  uploadedAttachment?: {
    name: string;
    url: string;
    uploadedAt: number;
  } | null;
};

const CommentsAndLog: FC<Props> = ({
  container,
  commentsLoading,
  comments,
  currentUserId,
  users,
  usersNotOnProject,
  logs,
  logsLoading,
  taskId,
  canEditComment,
  canViewPrivateComments,
  canCreatePrivateComments,
  canViewCommitComment,
  billingRights,
  owner,
  bugherdUrl,
  organizationId,
  guestVisible,
  createComment,
  deleteComment,
  updateComment,
  isSmallView,
  isAdminView,
  isNewSidebar,
  onPlanUpgradeClick,
  projectId,
  isExpandedView,
  apiDomain,
  assignGuestsAllowed,
  assignGuests,
  assignees,
  mentionableTasks,
  searchMentionableTasks,
  setActiveTask,
  section,
  uploadedAttachment
}) => {
  const [page, setPage] = useState<number>(1);

  return (
    <div
      className={cx(styles.commentsAndLogOuter, {
        [styles.commentsExpanded]: isExpandedView && !section
      })}
    >
      <Comments
        container={container}
        commentsLoading={commentsLoading}
        comments={comments}
        currentUserId={currentUserId}
        users={users}
        usersNotOnProject={usersNotOnProject}
        taskId={taskId}
        canEditComment={canEditComment}
        canViewPrivateComments={canViewPrivateComments}
        canCreatePrivateComments={canCreatePrivateComments}
        canViewCommitComment={canViewCommitComment}
        billingRights={billingRights}
        owner={owner}
        bugherdUrl={bugherdUrl}
        organizationId={organizationId}
        guestVisible={guestVisible}
        createComment={createComment}
        deleteComment={deleteComment}
        updateComment={updateComment}
        isSmallView={isSmallView}
        isAdminView={isAdminView}
        isNewSidebar={isNewSidebar}
        onPlanUpgradeClick={onPlanUpgradeClick}
        projectId={projectId}
        apiDomain={apiDomain}
        assignGuestsAllowed={assignGuestsAllowed}
        assignGuests={assignGuests}
        assignees={assignees}
        mentionableTasks={mentionableTasks}
        searchMentionableTasks={searchMentionableTasks}
        setActiveTask={setActiveTask}
        page={page}
        setPage={setPage}
        uploadedAttachment={uploadedAttachment}
        logs={logs}
        logsLoading={logsLoading}
        showDescriptionChanges={canViewPrivateComments}
      />
    </div>
  );
};

export default CommentsAndLog;
